import React from 'react'
import { ClientHomeUpdates } from './ClientHomeUpdates'
import { ModuleInfoCards } from './ModuleInfoCards'
import { ModuleRedirectCards } from './ModuleRedirectCards'

export const ClientHomePage = () => {
    return (
        <>
            <ModuleInfoCards />
            <ClientHomeUpdates />
            <ModuleRedirectCards />
        </>
    )
}
